export default {
  sessionSecondsLeftToShowModal: 60
}



// WEBPACK FOOTER //
// ./src/config/app.js